import axios from "../axios";

export async function fetchOrgCharts(controller) {
  return axios({
    method: "get",
    url: "/quality/org_charts",
    params: controller,
  })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error.response?.data || error);
    });
}

export async function fetchOrgChart(id) {
  return axios
    .get(`/quality/org_charts/${id}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error.response?.data || error);
    });
}

export async function createOrgChart(payload) {
  return axios
    .post("/quality/org_charts", { org_chart: payload })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error.response?.data || error);
    });
}

export async function updateOrgChart(payload) {
  const id = typeof payload === "string" ? payload : payload.id;
  return axios
    .put(`/quality/org_charts/${id}`, { org_chart: payload })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error.response?.data || error);
    });
}

export async function deleteOrgChart(payload) {
  const id = typeof payload === "string" ? payload : payload.id;
  return axios
    .delete(`/quality/org_charts/${id}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error.response?.data || error);
    });
}

export async function createOrgChartRevision(orgChartId) {
  return axios
    .post(`/quality/org_charts/${orgChartId}/create_revision`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error.response?.data || error);
    });
}

export async function approveOrgChartRevision(orgChartId, revisionId) {
  return axios
    .post(`/quality/org_charts/${orgChartId}/approve_revision`, {
      revision_id: revisionId,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error.response?.data || error);
    });
}

export async function fetchOrgChartRevision(orgChartId, revisionId) {
  return axios
    .get(`/quality/org_charts/${orgChartId}/revisions/${revisionId}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error.response?.data || error);
    });
}

export async function updateOrgChartRevision(orgChartId, revisionId, payload) {
  return axios
    .put(`/quality/org_charts/${orgChartId}/revisions/${revisionId}`, {
      revision: payload,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error.response?.data || error);
    });
}

export async function updateOrgChartNodes(orgChartId, revisionId, nodes) {
  return axios
    .put(`/quality/org_charts/${orgChartId}/revisions/${revisionId}/update_nodes`, {
      nodes: nodes,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error.response?.data || error);
    });
}

export async function updateOrgChartLinks(orgChartId, revisionId, links) {
  return axios
    .put(`/quality/org_charts/${orgChartId}/revisions/${revisionId}/update_links`, {
      links: links,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error.response?.data || error);
    });
}

export async function fetchOrgChartRevisions(orgChartId) {
  return axios
    .get(`/quality/org_charts/${orgChartId}/revisions`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error.response?.data || error);
    });
}

export async function exportOrgChartRevisionPDF(orgChartId, revisionId) {
  return axios
    .get(`/quality/org_charts/${orgChartId}/revisions/${revisionId}/export_pdf`, {
      responseType: 'blob',
    })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return Promise.reject(error.response || error);
    });
}

